/**
 * DB value → display label.
 *
 * The keys are persisted `Content.contentType` values. The « Plateforme »
 * section was renamed to « Engagements » for display only, so the key stays
 * `Plateformes` while the label changed.
 */
export const contentTypeLabels: Record<string, string> = {
	Lignes: 'Lignes',
	Plateformes: 'Engagements',
	Cartes: 'Jeu de cartes',
	LiensSociaux: 'Liens sociaux',
	LiensOutils: 'Outils',
	LiensFormulaires: 'Formulaires',
	Evenements: 'Événements',
}

/** Section URL slug → DB contentType value */
export const CONTENT_TYPE_SLUGS: Record<string, string> = {
	lignes: 'Lignes',
	engagements: 'Plateformes',
	cartes: 'Cartes',
}

/** DB contentType value → section URL path */
export const CONTENT_TYPE_TO_SLUG: Record<string, string> = {
	Lignes: 'lignes',
	Plateformes: 'engagements',
	Cartes: 'cartes',
	LiensSociaux: 'support',
	LiensOutils: 'support',
	LiensFormulaires: 'support',
	Evenements: 'evenements',
}

/** Content types shown on the /support page */
export const SUPPORT_CONTENT_TYPES = ['LiensOutils', 'LiensFormulaires']

export const VALID_CONTENT_TYPES = Object.keys(contentTypeLabels)
